import { Injectable } from '@angular/core';
import { Logger, LoggerFactory } from '../core/logger.service';
import { WidgetAutomationsService } from './widget-automations.service';
import { Widget, WidgetComponentSubType } from './widgets.model';
import { Automation } from '../automations/automations-models';
import { switchMap } from 'rxjs/operators';
import WidgetComponentHelpers from './widget-component-helpers';
import { IntegrationType } from 'app/automations/integrations-models';
import { WidgetService } from 'app/shared/services/widget.service';
import { AccountIdentifierConstants } from 'app/account/account-identifier-constants';
import { AutomationHelpers } from 'app/automations/automation-helpers';

@Injectable()
export class WidgetAutomationsDataService {
  private readonly logger: Logger;

  public existingAutomation: Automation | any;

  constructor(
    loggerFactory: LoggerFactory,
    private widgetAutomationsService: WidgetAutomationsService,
    private widgetService: WidgetService,
  ) {
    this.logger = loggerFactory.get('WidgetAutomationsDataService');
  }

  public updateAutomationName(automationId: string, automationName: string) {
    return this.widgetAutomationsService.getAutomationById(automationId).pipe(
      switchMap((automation: Automation) => {
        automation.name = automationName;
        return this.widgetAutomationsService.updateAutomation(automation);
      }),
    );
  }

  public combinationInputsForDifferentAccountIdentifier(identifier) {
    if (identifier === AccountIdentifierConstants.Telephone) {
      return [WidgetComponentSubType.InputTextPhone, WidgetComponentSubType.InternationalPhoneRegular];
    } else {
      return [WidgetComponentSubType.InputTextEmail];
    }
  }

  public isActionCanBeWithRealTime(widgetStates, nameAction, account, isRealTimeAction?): string {
    if (
      nameAction === IntegrationType.Brevo ||
      nameAction === IntegrationType.CleverReach ||
      nameAction === IntegrationType.Dotdigital ||
      nameAction === IntegrationType.Omnisend ||
      nameAction === IntegrationType.Shopware
    ) {
      return nameAction;
    }
    const widgetState = widgetStates.states ? widgetStates : { states: widgetStates };
    const subscriptionCheckboxComponents = WidgetComponentHelpers.getAllComponentsOfTypes(
      null,
      WidgetComponentHelpers.getAllComponentsOnWidget(widgetState as Widget),
      [WidgetComponentSubType.ButtonListSubscriptionCheckbox],
    );
    const components = WidgetComponentHelpers.getAllComponentsOfTypes(
      null,
      WidgetComponentHelpers.getAllComponentsOnWidget(widgetState as any),
      this.combinationInputsForDifferentAccountIdentifier(account.identifier),
    );
    if (nameAction) {
      if (
        !isRealTimeAction &&
        subscriptionCheckboxComponents?.length &&
        components &&
        components.length &&
        nameAction &&
        subscriptionCheckboxComponents[0].subscriptionCheckboxProperties?.sourceIntegration?.toLowerCase() ===
          nameAction?.toLowerCase()
      ) {
        return nameAction;
      }
      if (
        isRealTimeAction &&
        subscriptionCheckboxComponents?.length &&
        nameAction &&
        subscriptionCheckboxComponents[0].subscriptionCheckboxProperties?.sourceIntegration?.toLowerCase() ===
          nameAction?.toLowerCase()
      ) {
        return nameAction;
      }
    } else if (subscriptionCheckboxComponents?.length && components && components.length) {
      return subscriptionCheckboxComponents[0].subscriptionCheckboxProperties?.sourceIntegration;
    }
  }

  public isAllowFormMappingPropApplyInitial(app, toggleRealTime?) {
    if (AutomationHelpers.isBrevoDotVoyadoRuleRealTime(app) || toggleRealTime !== undefined) {
      if (!AutomationHelpers.hasPersistedFormMappedUpdateActions(this.existingAutomation, app.name)) {
        app.isFormMappingProp = true;
        if (app.name === IntegrationType.Voyado || app.name === IntegrationType.Rule) {
          app.isFormMappingProp = toggleRealTime;
        }
      } else {
        app.isFormMappingProp = false;
      }
    }
  }
}
